import './HelpButton.scss';
import {useSelector, useDispatch} from 'react-redux';
import {useState, useEffect} from 'react';
import {showAlert} from "../AlertBox/AlertBox";

export default function HelpButton({info_text}) {
    return (
        <svg className={"help-button"}
            onClick={() => showAlert('info', info_text)}
            style={{cursor: 'pointer'}} width="24px" height="24px" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path d="M12 17V11" stroke="#ffffff" strokeWidth="1.5"
                      strokeLinecap="round"></path>
                <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)"
                        fill="#ffffff"></circle>
                <path
                    d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                    stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"></path>
            </g>
        </svg>
    )
}